/* eslint-disable jsx-a11y/no-redundant-roles */
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { DialogOverlay, DialogContent } from '@reach/dialog'
import VisuallyHidden from '@reach/visually-hidden'
import '@reach/dialog/styles.css'
import * as styles from './Modal.module.scss'

const Modal = ({ open, onDismiss, initialFocusRef, children, className, name, theme }) => {
  const [t] = useTranslation()
  const themeColor = theme === 'light' ? '#fff' : '#000'

  return (
    <DialogOverlay
      className={(styles.DialogOverlay, className)}
      isOpen={open}
      onDismiss={onDismiss}
      initialFocusRef={initialFocusRef}
      data-qa="modal-overlay"
    >
      <DialogContent className={styles.DialogContent} aria-label={name} data-qa="modal-content">
        <button
          type="button"
          role="button"
          className={styles.CloseButton}
          onClick={onDismiss}
          data-qa="modal-close-button"
          aria-label={t('Modal.closeButtonAriaLable', {
            defaultValue: 'Close Main Navigation Modal',
          })}
        >
          <VisuallyHidden>{t('Modal.closeButtonLabel', { defaultValue: 'Close' })}</VisuallyHidden>
          <svg
            role="img"
            aria-hidden="true"
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="40"
            viewBox="0 0 34 40"
          >
            <path
              fill={themeColor}
              fillRule="evenodd"
              d="M27.822 14.613l1.951 1.932c.27.267.348.622.175.794l-9.932 9.836 9.932 9.835c.153.152.109.45-.092.702l-.083.092-1.951 1.932c-.24.237-.55.325-.737.22l-.064-.047-9.932-9.836-9.93 9.836c-.174.171-.533.094-.802-.173l-1.951-1.932c-.27-.267-.348-.623-.174-.794l9.93-9.835-9.93-9.836c-.154-.153-.11-.45.091-.702l.083-.092 1.951-1.932c.24-.238.55-.325.737-.221l.065.048 9.93 9.836 9.932-9.836c.173-.171.532-.094.801.173zM3.257 0c.86 0 1.55.238 2.068.713.519.475.82 1.133.906 1.973H5.158l-.035-.206c-.104-.533-.293-.926-.568-1.18-.31-.287-.742-.43-1.298-.43-.682 0-1.216.25-1.603.748-.388.5-.581 1.21-.581 2.13v.777l.005.256c.033.75.215 1.357.545 1.82.367.513.88.77 1.54.77.593 0 1.047-.133 1.364-.399.317-.266.527-.73.631-1.39h1.073l-.033.226c-.126.74-.431 1.318-.915 1.736-.532.461-1.238.691-2.12.691-.956 0-1.722-.34-2.299-1.018C.288 6.538 0 5.63 0 4.492v-.77l.006-.276c.03-.632.162-1.195.397-1.69.269-.565.65-1 1.142-1.302C2.038.151 2.61 0 3.257 0zm13.576 0c.649 0 1.22.155 1.715.465.495.31.875.76 1.142 1.349.267.589.4 1.274.4 2.056v.506l-.006.29c-.029.666-.16 1.254-.394 1.766-.267.586-.645 1.033-1.134 1.34-.489.31-1.06.463-1.712.463-.637 0-1.202-.155-1.695-.465-.493-.31-.875-.752-1.148-1.327-.272-.574-.412-1.239-.42-1.995V3.87l.007-.285c.03-.655.163-1.24.4-1.757.27-.591.652-1.044 1.147-1.357C15.63.157 16.195 0 16.833 0zm7.578 0c.555 0 1.051.106 1.486.32.436.212.773.506 1.012.88s.359.784.359 1.228h-1.073l-.008-.177c-.034-.401-.187-.723-.46-.966-.31-.277-.75-.415-1.316-.415-.527 0-.937.114-1.232.344-.294.23-.441.548-.441.955 0 .327.14.603.42.828.279.226.755.433 1.428.62.672.187 1.198.393 1.578.619.38.226.662.489.845.79.184.3.275.655.275 1.062 0 .65-.255 1.17-.767 1.561-.511.39-1.195.586-2.05.586a3.836 3.836 0 0 1-1.557-.316c-.482-.211-.853-.5-1.115-.867a2.102 2.102 0 0 1-.391-1.25h1.072l.007.158c.036.41.214.74.535.99.361.28.844.421 1.448.421.563 0 .995-.114 1.295-.341.3-.228.45-.538.45-.93 0-.393-.138-.697-.416-.912-.278-.214-.782-.426-1.512-.635-.916-.261-1.582-.581-1.998-.961a1.827 1.827 0 0 1-.626-1.407c0-.63.255-1.153.764-1.566C22.933.206 23.595 0 24.411 0zM8.967.11v7.151h3.835v.864H7.894V.11h1.073zm24.977 0v.87h-4.018v2.576h3.507v.864h-3.507v2.841H34v.864h-5.141V.11h5.085zm-17.11.798c-.675 0-1.206.254-1.593.763-.387.508-.587 1.214-.598 2.116v.59l.006.27c.035.793.229 1.427.58 1.901.392.527.93.79 1.615.79.69 0 1.223-.249 1.601-.746.378-.497.573-1.21.584-2.139V3.86l-.005-.254c-.032-.827-.223-1.472-.573-1.934-.386-.509-.925-.763-1.618-.763z"
            />
          </svg>
        </button>

        {children}
      </DialogContent>
    </DialogOverlay>
  )
}

Modal.propTypes = {
  children: PropTypes.node,
  onDismiss: PropTypes.func,
  initialFocusRef: PropTypes.object,
  open: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['light', 'dark']),
}

export { Modal }
export default Modal
